module.exports = __webpack_public_path__ + "img/matrix.c351eb4f.png";